export const DESTROY_USER_SESSION_PATH = '/logout';
export const MAIN_ID = 'exam-results-app';

export const mainElement = () => document.getElementById(MAIN_ID);

export const AGE = 'age';
export const BROWSER = 'browser';
export const REGION_NOT_ACTIVE = 'region_not_active';
export const HEALTH = 'health';
export const PRIORS = 'priors';
export const EXAM = 'exam';
export const ACUITY = 'acuity';
export const SINGLE_RX = 'single_rx';
export const GENERAL = 'general';
export const SUCCESS = 'success';
